export default process.env.DINGO_API_BASE ||
  (process.env.NODE_ENV === "production"
    ? "/api/dingo/"
    : "http://localhost:61031/");
